export default {
	AbbreviationSetups(state) {
		return state.AbbreviationSetups;
	}
};
